// extracted by mini-css-extract-plugin
module.exports = {"Appointment":"Appointment_Appointment__KIxLe","Appointment__Content":"Appointment_Appointment__Content__PtQHY"};